import classNames from "classnames";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Image from "next/image";
import Section from "@/components/Section/Section";
import { faArrowLeft, faArrowRight } from "@fortawesome/pro-regular-svg-icons";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
import Carousel, { PagingDots } from "nuka-carousel";
import Button from "@/components/UI/Button/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

interface Section26Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const CarouselSection = ({ job, page, section, ...props }: Section26Props) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(1);
  return (
    <Section section={section} {...props}>
      <SectionContainer section={section}>
        <SectionHeader section={section} />
        <div className="relative">
          <Carousel
            autoplay
            dragging={false}
            beforeSlide={(_, nextIndex) => {
              setCurrentSlideIndex(nextIndex);
            }}
            renderBottomCenterControls={(props) => {
              return <PagingDots {...props} />;
            }}
            renderCenterLeftControls={({ previousDisabled, previousSlide }) => (
              <Button
                aria-label="Go to previous button image"
                className="ml-4 h-16 w-16 rounded-full border-4 border-white shadow-lg shadow-vpBlue-200 lg:ml-40"
                disabled={previousDisabled}
                onClick={previousSlide}
              >
                <FontAwesomeIcon className="h-6 w-6" icon={faArrowLeft} />
              </Button>
            )}
            renderCenterRightControls={({ nextDisabled, nextSlide }) => (
              <Button
                aria-label="Go to next button image"
                className="mr-4 h-16 w-16 rounded-full border-4 border-white shadow-lg shadow-vpBlue-200 lg:mr-40"
                disabled={nextDisabled}
                onClick={nextSlide}
              >
                <FontAwesomeIcon className="h-6 w-6" icon={faArrowRight} />
              </Button>
            )}
            defaultControlsConfig={{
              pagingDotsClassName: "mx-2",
              pagingDotsContainerClassName: "!top-[45px]",
            }}
            cellAlign="center"
            cellSpacing={48}
            pauseOnHover
            slideIndex={1}
            slidesToShow={3}
            animation="zoom"
            zoomScale={0.7}
            wrapAround
          >
            {section?.Carousel?.Slides.data?.map((slide: any, index: any) => {
              const isActive = currentSlideIndex === index;
              const isLeftSlide = index === currentSlideIndex - 1;
              const isRightSlide = index === currentSlideIndex + 1;

              return (
                <div
                  key={index}
                  className={classNames("relative flex", {
                    "justify-end": isRightSlide,
                    "justify-start": isLeftSlide,
                    "justify-center": isActive,
                  })}
                >
                  <div style={isActive === false ? { width: "60%", overflow: "hidden" } : {}}>
                    <Image
                      alt={slide?.attributes?.alternativeText}
                      className="block"
                      key={slide?.id}
                      src={slide?.attributes?.url}
                      width={800}
                      height={0}
                      style={{
                        height: "auto",
                        width: "800px",
                        maxWidth: "800px",
                      }}
                    />
                  </div>
                </div>
              );
            })}
          </Carousel>
          <div>
            <div
              className="absolute left-0 top-0 z-0 h-full w-1/4"
              style={{
                background:
                  "linear-gradient(90deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0) 100%)",
              }}
            />
            <div
              className="absolute right-0 top-0 z-0 h-full w-1/4"
              style={{
                background:
                  "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.7) 50%, rgba(255,255,255,0.9) 100%)",
              }}
            />
          </div>
        </div>
      </SectionContainer>
    </Section>
  );
};

export default CarouselSection;
